// Status badge pill - dynamic status computed from signOnDate/signOffDate vs today
import React from 'react';
import { cn } from 'lib/utils';
import { computeCrewStatus, CREW_STATUS } from '../../utils/compute-crew-status';

const statusConfig = {
  [CREW_STATUS.ONBOARD]: {
    label: 'Onboard',
    className: 'tw-bg-emerald-50 tw-text-emerald-700 tw-border-emerald-200',
  },
  [CREW_STATUS.INVITED]: {
    label: 'Pending',
    className: 'tw-bg-gray-100 tw-text-gray-600 tw-border-gray-200',
  },
  [CREW_STATUS.PENDING]: {
    label: 'Pending',
    className: 'tw-bg-gray-100 tw-text-gray-600 tw-border-gray-200',
  },
  [CREW_STATUS.ON_LEAVE]: {
    label: 'On Leave',
    className: 'tw-bg-blue-50 tw-text-blue-700 tw-border-blue-200',
  },
  [CREW_STATUS.SICK_LEAVE]: {
    label: 'Sick Leave',
    className: 'tw-bg-red-50 tw-text-red-700 tw-border-red-200',
  },
};

const badgeBase = 'tw-inline-flex tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-border tw-whitespace-nowrap';

const CrewStatusBadge = ({ status, signOnDate, signOffDate }) => {
  const crewStatus = computeCrewStatus({ signupStatus: status, signOnDate, signOffDate });
  const config = statusConfig[crewStatus] || statusConfig[CREW_STATUS.PENDING];

  return (
    <div className="tw-flex tw-flex-col tw-items-start tw-gap-1.5">
      <span className={cn(badgeBase, config.className)}>
        {config.label}
      </span>
      {crewStatus === CREW_STATUS.INVITED && (
        <span className={cn(badgeBase, 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200')}>
          Invited
        </span>
      )}
    </div>
  );
};

export default CrewStatusBadge;
